import { cloudChiprApi } from "../../../../services/cloudchipr.api";

export const resourceExplorerViewsHierarchySelector =
  cloudChiprApi.endpoints.getUsersMeOrganisationsCurrentResourceExplorerViewsHierarchy.select(
    {},
  );
